import {createMetaReducer, createMiddleware} from 'redux-beacon';
import GoogleTagManager from '@redux-beacon/google-tag-manager';
import {eventsMap} from "./events/eventsMap";

// CONSTANTS #############################################

export const hitType = {
	PAGE_VIEW: 'pageview',
	SCREEN_VIEW: 'screenview',
	EVENT: 'event',
	TRANSACTION: 'transaction',
	ITEM: 'item',
	SOCIAL: 'social',
	EXCEPTION: 'exception',
	TIMING: 'timing',
};

export const eventType = {
	PAGE_VIEW: 'pageview',
};

// MAIN #############################################

// create instance, middleware and reducers
const gtm = GoogleTagManager();
export const gtmMiddleware = createMiddleware(eventsMap, gtm);
export const gtmMetaReducer = createMetaReducer(eventsMap, gtm);